// extracted by mini-css-extract-plugin
module.exports = {"casestudies":"styles_casestudies__MlAvY","card":"styles_card__O1vUj","pulse":"styles_pulse____Voo","jump":"styles_jump__cu8Be"};